import {
  GET_CASES_SUCCESS,
  SET_SORT_BY,
  SET_SEARCH_QUERY,
} from '@actions/cases';

const defaultState = {
  data: [],
  sortBy: 'date',
  sortByOptions: [
    {
      id: 0,
      name: 'Date',
      value: 'date',
    },
    {
      id: 1,
      name: 'Name',
      value: 'name',
    },
  ],
  searchQuery: '',
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_CASES_SUCCESS: {
      return {
        ...state,
        data: [...action.payload],
      };
    }
    case SET_SORT_BY: {
      return {
        ...state,
        sortBy: action.sortBy,
      };
    }
    case SET_SEARCH_QUERY: {
      return {
        ...state,
        searchQuery: action.searchQuery,
      };
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/cases.js